import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["destroyField"]

  // Rows backed by accepts_nested_attributes_for (corrections, scale
  // readings, scale usages) carry a destroyField target: removal must keep
  // the row's inputs in the DOM (hidden) so its _destroy=1 flag still
  // submits. Rows with no destroyField (plain array-style params, e.g.
  // checklist template items) have no such flag to rely on, so removal
  // takes the element out of the DOM entirely instead — otherwise its
  // still-filled-in values would keep being submitted after "removal".
  remove(event) {
    event.preventDefault()
    if (!confirm("Remove this item?")) return

    if (this.hasDestroyFieldTarget) {
      this.destroyFieldTarget.value = "1"
      this.element.dispatchEvent(new Event("change", { bubbles: true }))
      this.element.style.transition = "opacity 0.2s ease"
      this.element.style.opacity = "0"
      setTimeout(() => this.element.classList.add("d-none"), 200)
    } else {
      this.element.style.transition = "opacity 0.2s ease"
      this.element.style.opacity = "0"
      setTimeout(() => this.element.remove(), 200)
    }
  }
}
